// I guess this export is deprecated.
export { default } from '../modules/cache'


//////////////////
// WEBPACK FOOTER
// ../node_modules/javascript-time-ago/cache/index.js
// module id = 3268
// module chunks = 0